import React, { useState, useRef } from 'react';
import Modal from 'cccisd-modal';
import axios from 'cccisd-axios';
import { Formik, Form, Field, CccisdSelect } from 'cccisd-formik';
import { updateSessionDeploymentInfo } from '../../helpers';
import MessageForm from '../Messages/Form';
import ClipboardIcon from 'cccisd-icons/clipboard6';
import notification from 'cccisd-notification';

const Boilerplate = window.cccisd.boilerplate;

const DropdownModal = ({
    value,
    contacts,
    reloadTable,
    assignmentPlanId,
    options,
    loadData,
    session,
    closeStudentContactsModal,
    contactTypes,
}) => {
    const [contactInfo, setContactInfo] = useState({});
    const [assessmentLink, setAssessmentLink] = useState('');
    const [currentSessionDeploymentInfo, setCurrentSessionDeploymentInfo] = useState({});
    const modal = useRef();
    const messageRef = useRef();

    const submit = async values => {
        try {
            const match = contacts.find(contact => contact.pawn.pawnId === +values.contact);
            if (match) {
                const planIds = match.fields.assignment_plan_ids ? JSON.parse(match.fields.assignment_plan_ids) : [];
                planIds.push(assignmentPlanId);

                const response = await axios.put(
                    Boilerplate.route('api.nexus.pawn.update', {
                        pawn: match.pawn.pawnId,
                    }),
                    {
                        pawnHash: match.pawn.pawnHash,
                        assignment_plan_ids: planIds,
                    }
                );

                if (response?.data?.status === 'success') {
                    notification({ message: 'Contact added!', type: 'success' });
                    modal.current.close();
                    loadData();

                    if (session) {
                        await updateSessionDeploymentInfo(
                            [
                                {
                                    contactType: match.fields.contactType,
                                    email: match.fields.contactEmail,
                                    pawnId: response.data.data.id,
                                    respondentHash: response.data.data.respondent_hash,
                                },
                            ],
                            session
                        ).then(res => {
                            const sessionDeploymentId =
                                res.find(
                                    sessionDeploymentInfo => sessionDeploymentInfo.pawnId === response.data.data.id
                                )?.deploymentId || null;
                            const link = Boilerplate.url(
                                `/sessionPlayer/${sessionDeploymentId}/${assignmentPlanId}/${session.sessionId}/${
                                    match.fields.contactType
                                }/${response.data.data.id}/${
                                    response.data.data.random_hash
                                }?s=${session.settings.options.join(',')}`
                            );
                            setAssessmentLink(link);
                            setCurrentSessionDeploymentInfo({
                                pawnId: response.data.data.id,
                                deploymentId: sessionDeploymentId,
                            });
                        });

                        setContactInfo({ ...match, ...response.data });
                        messageRef.current.open();
                    }
                } else {
                    notification({ message: 'An error occured adding contact', type: 'danger' });
                }
            } else {
                notification({ message: 'This contact could not be found', type: 'danger' });
            }
        } catch (e) {
            console.error(e);
            notification({ message: 'An error occured adding contact', type: 'danger' });
        }
    };

    const filteredOptions = options.filter(option => {
        if (contactTypes && option.type) {
            return contactTypes.includes(option.type);
        }
        return true;
    });

    return (
        <div>
            {session && (
                <Modal
                    trigger={null}
                    ref={messageRef}
                    render={({ closeModal }) => {
                        const label = session.planLabel;
                        return (
                            <MessageForm
                                sessionDeploymentInfo={currentSessionDeploymentInfo}
                                contact={{ fields: { contactEmail: contactInfo.fields?.contactEmail } }}
                                row={{ label }}
                                label={label}
                                link={assessmentLink}
                                closeModal={closeModal}
                                messageSuccess={() => closeStudentContactsModal && closeStudentContactsModal()}
                                action="assessment_plan_invite"
                            />
                        );
                    }}
                />
            )}

            <Modal
                ref={modal}
                trigger={
                    <button type="button" className="btn btn-primary" style={{ marginRight: '1em' }}>
                        <ClipboardIcon spaceRight /> Add Existing Contact
                    </button>
                }
                title="Add Existing Contact"
                beforeClose={() => reloadTable()}
            >
                <div>
                    <Formik
                        onSubmit={submit}
                        render={() => (
                            <Form>
                                <Field
                                    name="contact"
                                    component={CccisdSelect}
                                    label="Existing Contacts"
                                    options={filteredOptions}
                                />
                                <button className="btn btn-primary" type="submit">
                                    Submit
                                </button>
                            </Form>
                        )}
                    />
                </div>
            </Modal>
        </div>
    );
};

export default DropdownModal;
